import React from 'react'
import * as R from 'ramda'
import moment from 'moment'
import { Icon } from '@material-ui/core'

import { usePlanAddManual } from 'commons/usePlanAddManual'
import { usePlan, useSubscription } from 'commons/useSubscription'
import { getPlanType, PlanPriceType, useNextPlan } from 'commons/plan'
import { useIsPlaceInGracePeriod } from 'commons/useIsPlaceRestricted'

export function BadgeBillingOverviewNotification() {
  const plan = usePlan()
  const nextPlan = useNextPlan()
  const subscription = useSubscription()
  const [isPlanAddManual] = usePlanAddManual()
  const isAnnual = getPlanType(R.prop('id', plan)) === PlanPriceType.ANNUAL
  const nextBilling = R.prop('nextBillingDate', subscription)
  const expireDate = moment(R.prop('endsAt', subscription) ?? nextBilling)
  const today = moment().utc()
  const countExpireDate = expireDate.diff(today, 'days')
  const isThirtyDay = countExpireDate > 0 && countExpireDate <= 30
  const isSevenDay = countExpireDate > 0 && countExpireDate <= 7
  const isPlaceInGracePeriod = useIsPlaceInGracePeriod()

  const isEnding = R.isNil(nextBilling) && R.isNil(nextPlan)
  const countDownAnnual = isAnnual && isThirtyDay
  const isShowCountDown = countDownAnnual || isSevenDay

  if (
    (isPlanAddManual && isShowCountDown && isEnding) ||
    today.isSame(expireDate, 'day') ||
    isPlaceInGracePeriod
  ) {
    return <Icon>error_outline</Icon>
  }

  return null
}

export default BadgeBillingOverviewNotification
